module.exports = __webpack_public_path__ + "static/media/Scene 3.43cb5372.jpg";